import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import { useMediaQuery } from '@material-ui/core';


export default function MainInput(props) {

    const desktop = useMediaQuery('(min-width:769px)');

    const useStyles = makeStyles((theme) => ({
        root: {
            padding: '2px 4px',
            display: 'flex',
            alignItems: 'center',
            width: desktop ? "100%" : "96%",
            backgroundColor: '#ffffff',
            borderRadius: '4px'
        },
        input: {
            padding: 0,
            flex: 1,
        },
        iconButton: {
            padding: "10px 19px 10px 10px",
        },
        divider: {
            height: 28,
            margin: 4,
        },
    }));
    const classes = useStyles();

    return (
        <div component="form" className={classes.root}>
            <img src="/img/search-icon.svg" className={classes.iconButton}></img>
            <InputBase
                className={classes.input}
                {...props}
            />
        </div>
    );
}